import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { DivisionDetailReportTableContent } from "../../../Common/Table/tableContent";
import MenuItem from '@material-ui/core/MenuItem';
import { Pagination, PageHeader, paginate } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import { Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { divisionSummaryDetailReportSchema } from "../divisionSummaryDetailReportSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import CreatePDF from './createPdf';
import ReactToPrint from "react-to-print";
import _, { flatMap } from 'lodash';
import $ from 'jquery';

const screenCode = 'DIVISIONSUMMARYDETAILREPORT'

export function DivisionSummaryDetailReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        estateID: "0",
        searchDate: ""
    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(divisionSummaryDetailReportSchema).options({ allowUnknown: true });
    const [data, setdata] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const DropdownChanges = Object.freeze({ "group": 1, "operationEntity": 2 })
    const [reportData, setReportData] = useState([]);
    const [isViewTable, setIsViewTable] = useState(true);
    const [columeNames, setColumeNames] = useState([]);
    const [allTotal, setAllTotal] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const contentRowNames = ["collectionPointName", "fieldName", "GENERALgrossAmount", "GENERALtotalDeduction", "GENERALnetAmount",
        "RSMgrossAmount", "RSMtotalDeduction", "RSMnetAmount", "CASHgrossAmount", "CASHtotalDeduction", "CASHnetAmount", "grossAmount",
        "totalDeduction", "netAmount", "gtnGross", "gtnDeduc", "gtnNet", "gtnBag", "grnGross", "grnDeduc", "grnNet", "grnBag",
        "VgrossAmount", "VDeduction", "VnetAmount", "VBag", "CVgrossAmount", "CVDeduction", "CVnetAmount"]
    const [csvHeaders, setCsvHeaders] = useState([
        { label: "Collection Point", value: "collectionPointName" },
        { label: "Field Name", value: "fieldName" },
        { label: "General Gross Amount", value: "GENERALgrossAmount" },
        { label: "General Deduction", value: "GENERALtotalDeduction" },
        { label: "General Net Amount", value: "GENERALnetAmount" },
        { label: "RSM Gross Amount", value: "RSMgrossAmount" },
        { label: "RSM Deduction", value: "RSMtotalDeduction" },
        { label: "RSM Net Amount", value: "RSMnetAmount" },
        { label: "CASH Gross Amount", value: "CASHgrossAmount" },
        { label: "CASH Deduction", value: "CASHtotalDeduction" },
        { label: "CASH Net Amount", value: "CASHnetAmount" },
        { label: "Total Gross Amount", value: "grossAmount" },
        { label: "Total Deduction", value: "totalDeduction" },
        { label: "Total net Amount", value: "netAmount" },
        { label: "Field Gross Weight", value: "gtnGross" },
        { label: "Field Deduction", value: "gtnDeduc" },
        { label: "Field Net Weight", value: "gtnNet" },
        { label: "Field No Of Bags", value: "gtnBag" },
        { label: "Factory Gross Weight", value: "grnGross" },
        { label: "Factory Deduction", value: "grnDeduc" },
        { label: "Factory Net Weight", value: "grnNet" },
        { label: "Factory No Of Bags", value: "grnBag" },
        { label: "Field To Factory Gross Varience", value: "VgrossAmount" },
        { label: "Field To Factory Deduction Varience", value: "VDeduction" },
        { label: "Field To Factory Net Varience", value: "VnetAmount" },
        { label: "Field To Factory Bag Varience", value: "VBag" },
        { label: "Checkroll To Factory Gross Varience", value: "CVgrossAmount" },
        { label: "Checkroll To Factory Deduction Varience", value: "CVDeduction" },
        { label: "Checkroll To Factory Net Varience", value: "CVnetAmount" },
    ]);
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        sDate: "",
    });

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown()
        )
        checkDisbursement();
    }, [searchData.groupID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWDIVISIONSUMMARYDETAILREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        getGroupsForDropDown();
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getEstatesForDropdown() {
        const data = await service.getEstatesByGroupID(searchData.groupID);
        setEstates(data);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, divisionSummaryDetailReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
    }
    async function handleSearch(e) {
        destroyDataTable();
        setIsTableHide(true);
        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        setIsViewTable(true);
        const reportData = await service.GetDivisionSummaryDetailReportData(searchData.estateID, searchData.searchDate);
        var factoryResultData = reportData.data.factoryData;
        var fieldResultData = reportData.data.feildData;

        var mergedFactoryResult = mergeFactoryData(factoryResultData)

        var mergedRSMPluckingResult = mergeRSMPluckingData(fieldResultData)
        var mergedGENERALPluckingResult = mergeGENERALPluckingData(fieldResultData)
        var mergedCASHPluckingResult = mergeCASHPluckingData(fieldResultData)

        var fieldToFactoryVarien = fieldToFactoryVarience(mergedFactoryResult)
        var pluckingToatl = plukingCollectionTotal(fieldResultData)
        var CheckRollVarienc = checkRollVarience(pluckingToatl, mergedFactoryResult)

        var joinedArray = _.merge(_.keyBy(mergedRSMPluckingResult, 'fieldID'), _.keyBy(mergedGENERALPluckingResult, 'fieldID'), _.keyBy(mergedCASHPluckingResult, 'fieldID'), _.keyBy(mergedFactoryResult, 'fieldID'), _.keyBy(fieldToFactoryVarien, 'fieldID'),
            _.keyBy(pluckingToatl, 'fieldID'), _.keyBy(CheckRollVarienc, 'fieldID'));
        var joinedResult = [];
        var finalResult = [];

        Object.keys(joinedArray).forEach(x => joinedResult.push(joinedArray[x]));
        joinedResult.forEach(x => {
            finalResult.push(x);
        });
        finalResult.forEach(x => {
            x.grossAmount = x.grossAmount.toFixed(1)
            x.netAmount = x.netAmount.toFixed(1)
            x.totalDeduction = x.totalDeduction.toFixed(1)
        });
        console.log("finalResult", finalResult);



        setReportData(finalResult);
        setCsvData(finalResult);
        setIsTableHide(false);
        setSelectedSearchData();
        createDataTable();
    }

    function mergeFactoryData(pluckingResult) {
        var mergedPluckingResult = [];

        pluckingResult.forEach(x => {

            var isPluckingDataExist = mergedPluckingResult.find(y => y.fieldID === x.fieldID)

            if (isPluckingDataExist) {
                isPluckingDataExist.grnBag += x.grnBag;
                isPluckingDataExist.grnDeduc += x.grnDeduc;
                isPluckingDataExist.grnGross += x.grnGross;
                isPluckingDataExist.grnNet += x.grnNet;
                isPluckingDataExist.gtnBag += x.gtnBag;
                isPluckingDataExist.gtnDeduc += x.gtnDeduc;
                isPluckingDataExist.gtnGross += x.gtnGross;
                isPluckingDataExist.gtnNet += x.gtnNet;

            } else {
                mergedPluckingResult.push(x);
            }

        });

        return mergedPluckingResult;
    }

    function checkRollVarience(pluckingToatl, mergedFactoryResult) {
        var merged = _.merge(_.keyBy(pluckingToatl, 'fieldID'), _.keyBy(mergedFactoryResult, 'fieldID'));
        var values = _.values(merged);
        var Result = [];

        values.forEach(x => {
            if (x.grnGross !== undefined || x.grnNet !== undefined || x.grnDeduc !== undefined) {
                Result.push({
                    ["CVgrossAmount"]: (x.grnGross === undefined ? 0 : x.grnGross - x.grossAmount).toFixed(1),
                    ["CVnetAmount"]: (x.grnNet === undefined ? 0 : x.grnNet - x.netAmount).toFixed(1),
                    ["CVDeduction"]: (x.grnDeduc === undefined ? 0 : x.grnDeduc - x.totalDeduction).toFixed(1),
                    fieldID: x.fieldID
                });
            }
            else {
                Result.push({
                    ["CVgrossAmount"]: (x.grossAmount).toFixed(1),
                    ["CVnetAmount"]: (x.netAmount).toFixed(1),
                    ["CVDeduction"]: (x.totalDeduction).toFixed(1),
                    fieldID: x.fieldID
                });
            }
        });
        return Result;
    }

    function mergeRSMPluckingData(pluckingResult) {
        var Result = [];
        pluckingResult.forEach(x => {
            if (x.narration == 'RSM') {
                Result.push({
                    ["RSMgrossAmount"]: (x.grossAmount).toFixed(1),
                    ["RSMnetAmount"]: (x.netAmount).toFixed(1),
                    ["RSMtotalDeduction"]: (x.totalDeduction).toFixed(1),
                    fieldID: x.fieldID
                });
            }
        });
        return Result;
    }
    function mergeGENERALPluckingData(pluckingResult) {
        var Result = [];
        pluckingResult.forEach(x => {
            if (x.narration == 'GENERAL') {
                Result.push({
                    ["GENERALgrossAmount"]: (x.grossAmount).toFixed(1),
                    ["GENERALnetAmount"]: (x.netAmount).toFixed(1),
                    ["GENERALtotalDeduction"]: (x.totalDeduction).toFixed(1),
                    fieldID: x.fieldID
                });
            }
        });
        return Result;
    }
    function mergeCASHPluckingData(pluckingResult) {
        var Result = [];
        pluckingResult.forEach(x => {
            if (x.narration === 'KILO') {
                Result.push({
                    ["CASHgrossAmount"]: (x.grossAmount).toFixed(1),
                    ["CASHnetAmount"]: (x.netAmount).toFixed(1),
                    ["CASHtotalDeduction"]: (x.totalDeduction).toFixed(1),
                    fieldID: x.fieldID
                });
            }
        });
        return Result;
    }
    function fieldToFactoryVarience(fieldToFacVarience) {
        var Result = [];

        fieldToFacVarience.forEach(x => {
            if (x.grnGross !== undefined || x.grnNet !== undefined || x.grnDeduc !== undefined) {
                Result.push({
                    ["VgrossAmount"]: (x.grnGross === undefined ? 0 : x.grnGross - x.gtnGross).toFixed(1),
                    ["VnetAmount"]: (x.grnNet === undefined ? 0 : x.grnNet - x.gtnNet).toFixed(1),
                    ["VDeduction"]: (x.grnDeduc === undefined ? 0 : x.grnDeduc - x.gtnDeduc).toFixed(1),
                    ["VBag"]: (x.grnBag - x.gtnBag),
                    fieldID: x.fieldID
                });
            }
            else {
                Result.push({
                    ["VgrossAmount"]: (x.gtnGross).toFixed(1),
                    ["VnetAmount"]: (x.gtnNet).toFixed(1),
                    ["VDeduction"]: (x.gtnDeduc).toFixed(1),
                    ["VBag"]: (x.gtnBag),
                    fieldID: x.fieldID
                });
            }
        });

        return Result;
    }

    function plukingCollectionTotal(fieldToFacVarience) {
        var mergedPluckingResult = [];

        fieldToFacVarience.forEach(x => {

            if (x.narration === 'KILO' || x.narration == 'GENERAL' || x.narration == 'RSM') {

                var isPluckingDataExist = mergedPluckingResult.find(y => y.fieldID === x.fieldID)

                if (isPluckingDataExist) {
                    isPluckingDataExist.grossAmount += x.grossAmount;
                    isPluckingDataExist.netAmount += (x.netAmount);
                    isPluckingDataExist.totalDeduction += (x.totalDeduction);
                    isPluckingDataExist.fieldID = x.fieldID;

                } else {
                    mergedPluckingResult.push(x);
                }

            }
        });

        return mergedPluckingResult;
    }

    function checkUndifined(value) {
        if (value === undefined || value === NaN || value === "-") {
            return 0;
        } else {
            return value;
        }
    }

    function setSelectedSearchData() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchData.groupID],
            estate: estates[searchData.estateID],
            sDate: searchData.searchDate
        })
    }

    function checkDisbursement() {
        if (searchData.month === '') {
            setIsViewTable(true);
        }
        else {
            setIsViewTable(false);
        }
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }
    function destroyDataTable() {
        $('#totalCrop').DataTable().destroy();
    }

    function createDataTable() {
        $('#totalCrop').DataTable();
    }

    function createFile() {
        var settings = {
            sheetName: 'Division Summary Detail Report',
            fileName: 'Division Summary Detail Report',
            writeOptions: {}
        }

        xlsx(csvHeaders, csvData, settings, true)
    }


    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Division Summary Detail Report"
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md-4">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        labelId="groupID"
                                        id="groupID"
                                        name="groupID"
                                        value={searchData.groupID}
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        onChange={(e) => handleChange(e)}
                                    >
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && (
                                        <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                    )}
                                </div>
                                <div className="col-md-4">
                                    <InputLabel shrink id="estateID">Estate *</InputLabel>
                                    <Select
                                        fullWidth
                                        labelId="estateID"
                                        id="estateID"
                                        name="estateID"
                                        value={searchData.estateID}
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        onChange={(e) => handleChange(e)}
                                    >
                                        <MenuItem value="0">--Select Estate--</MenuItem>
                                        {generateDropDownMenu(estates)}
                                    </Select>
                                    {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                </div>
                                <div className="col-md-4">
                                    <InputLabel shrink id="searchDate">Search Date *</InputLabel>
                                    <TextField
                                        fullWidth
                                        id="searchDate"
                                        name="searchDate"
                                        type="date"
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </div>
                            {isTableHide ? null :
                                <Grid item md={12} xs={12}>
                                    <table
                                        id="totalCrop"
                                        style={{
                                            display: "block", overflowX: "auto", whiteSpace: "nowrap"
                                            , borderColor: "white"
                                        }}>
                                        <thead>
                                            <tr>
                                                <th style={{ fontWeight: "bold", textAlign: "center" }} rowSpan="3">Division<br /></th>
                                                <th style={{ fontWeight: "bold", textAlign: "center" }} rowSpan="3">Field<br /></th>
                                                <th style={{ fontWeight: "bold", textAlign: "center" }} colSpan="12">Plucking Collection<br /></th>
                                                <th style={{ fontWeight: "bold", textAlign: "center" }} rowSpan="2" colSpan="4">Field Collection<br /></th>
                                                <th style={{ fontWeight: "bold", textAlign: "center" }} rowSpan="2" colSpan="4">Factory Collection<br /></th>
                                                <th style={{ fontWeight: "bold", textAlign: "center" }} rowSpan="2" colSpan="4">Field To Factory Varience<br /></th>
                                                <th style={{ fontWeight: "bold", textAlign: "center" }} rowSpan="2" colSpan="3">Checkroll To Factory Varience<br /></th>
                                            </tr>
                                            <tr>
                                                <th style={{ fontWeight: "bold", textAlign: "center" }} colSpan="3">General<br /></th>
                                                <th style={{ fontWeight: "bold", textAlign: "center" }} colSpan="3">RSM<br /></th>
                                                <th style={{ fontWeight: "bold", textAlign: "center" }} colSpan="3">Cash<br /></th>
                                                <th style={{ fontWeight: "bold", textAlign: "center" }} colSpan="3">Total<br /></th>
                                            </tr>
                                            <tr>
                                                <th style={{ fontWeight: "bold" }} scope="col" > G <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > D <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > N <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > G <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > D <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > N <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > G <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > D <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > N <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > G <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > D <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > N <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > G <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > D <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > N <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > NOB <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > G <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > D <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > N <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > NOB <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > G <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > D <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > N <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > NOB <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > G <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > D <br /></th>
                                                <th style={{ fontWeight: "bold" }} scope="col" > N <br /></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <DivisionDetailReportTableContent
                                                data={reportData}
                                                contentRowNames={contentRowNames}
                                                hasEdit={false}
                                            />
                                        </tbody>
                                    </table>
                                </Grid>
                            }
                        </form>
                        {
                            (reportData.length == 0 || reportData == undefined || reportData == null || reportData == []) ?
                                null : <div className="pt-3">
                                    <ReactToPrint
                                        trigger={() => <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Create PDF"
                                        />}
                                        content={() => componentRef.current}
                                        documentTitle={'Division Summary Detail Report'}
                                    />
                                    <div hidden={true}>
                                        <CreatePDF ref={componentRef} data={reportData} rowNames={contentRowNames}
                                            searchData={selectedSearchValues} totalRow={allTotal} columeNames={columeNames} />
                                    </div>
                                    <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Excel"
                                        onClick={createFile}
                                    />
                                </div>
                        }
                    </div>
                </div>
            </div>
        </Fragment >
    );
}



